/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { OrganisationDestroyPathParams, OrganisationDestroyResponse } from '../types/OrganisationDestroy'

/**
 * DELETE /organisations/:organisation
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::destroy
 */
export async function organisationDestroy(
	organisation: OrganisationDestroyPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationDestroyResponse>> {
	return axiosInstance.delete(`/organisations/${organisation}`, config)
}
